// utils/callStatusLabels.js
// Display-only labels for CallLog.currentStatus — the underlying stored value
// (and everything sent to/matched against the backend) stays exactly as-is
// ("Follow-up", etc.); only what the user reads on screen changes here.
export const CALL_STATUS_LABELS = {
  "Not Answering":  "Not Answering",
  "New":            "New",
  "Interested":     "Interested",
  "Negotiating":    "Negotiating",
  "Not Interested": "Not Interested",
  "Follow-up":      "Follow-up List",
  "Closed":         "Closed",
};

export const formatCallStatus = (status) => CALL_STATUS_LABELS[status] || status;
